module.exports = new __parcel__URL__("Original.f51eff19.png").toString();